/** Available module namespaces in the system */
export type Namespace =
  | 'logger'
  | 'clicks'
  | 'record'
  | 'userComments'
  | 'actions'
  | 'tags'
  | 'customEvents'
  | 'navigations'
  | 'identityUpdater'
  | 'performance'
  | 'form';

/**
 * Types of console operations that can be tracked.
 * Maps to standard console methods and additional custom operations.
 */
export enum ConsoleType {
  /** Debug level messages */
  DEBUG = 'debug',
  /** Error level messages */
  ERROR = 'error',
  /** Info level messages */
  INFO = 'info',
  /** Standard log messages */
  LOG = 'log',
  /** Warning messages */
  WARN = 'warn',
  /** Directory output */
  DIR = 'dir',
  /** XML directory output */
  DIRXML = 'dirxml',
  /** Table formatted output */
  TABLE = 'table',
  /** Stack trace output */
  TRACE = 'trace',
  /** Start of a console group */
  GROUP = 'group',
  /** Start of a collapsed console group */
  GROUPCOLLAPSED = 'groupCollapsed',
  /** End of a console group */
  GROUPEND = 'groupEnd',
  /** Clear console output */
  CLEAR = 'clear',
  /** Counter label output */
  COUNT = 'count',
  /** Reset counter label */
  COUNTRESET = 'countReset',
  /** Assertion check */
  ASSERT = 'assert',
  /** Start of profiling */
  PROFILE = 'profile',
  /** End of profiling */
  PROFILEEND = 'profileEnd',
  /** Start of timing */
  TIME = 'time',
  /** Log timing progress */
  TIMELOG = 'timeLog',
  /** End of timing */
  TIMEEND = 'timeEnd',
  /** Timestamp marker */
  TIMESTAMP = 'timeStamp',
  /** Context information */
  CONTEXT = 'context',
  /** Memory usage information */
  MEMORY = 'memory',
}
